import { defineCapability } from 'nest/capabilities';
import { args } from 'nest/common/args';

export const TOGGLE_CSAT_SURVEY_CAP = defineCapability({
  name: 'TOGGLE_CSAT_SURVEY_CAP' as const,
  args: {
    surveyId: args.number(),
  },
});
